import React__default from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MenuNav from '../../../../shared/utils/menuNavigation/menuNavigation.js';
import { cssClassPrefix } from '../../../../shared/constants/generalConstants.js';

/**
 * Copyright 2021, IntraLinks, Inc, All rights reserved.
 */
var BASE_CSS = "".concat(cssClassPrefix, "-header-action");
var ulRef = /*#__PURE__*/React__default.createRef();
var escapeCallBack = function escapeCallBack(e) {
  e.currentTarget.trigger.click();
  e.currentTarget.trigger.focus();
};
var mobileMenuNav = new MenuNav({
  escapeCallBack: escapeCallBack,
  activeClass: 'active-item'
});
var mobielMenuKeyDownHandler = mobileMenuNav.keyHandler;
var mobileMenuFocusHandler = function mobileMenuFocusHandler(e) {
  mobileMenuNav.nav(0, e);
};

/**
 * IlHeaderAction Component
 * #### Action with dropdown options
 * ```javascript
 * <IlHeaderMobileMenuAction>
 *    <IlHeaderAction
 *       title=""
 *       onClick={() => void}
 *       icon={ReactElement}
 *       caretDown={ReactElement}
 *       fullName= "Jonh Smith",
 *       email= "Jonh@intralinks.com">
 *        <IlHeaderActionItem itemText="" hasDivider={boolean} onClick={() => void} active={boolean} closeMenuOnClick={boolean}>
 *    </IlHeaderAction>
 * </IlHeaderMobileMenuAction>
 * ```
 */
var IlHeaderMobileMenuAction = function IlHeaderMobileMenuAction(props) {
  var _props$icon = props.icon,
    icon = _props$icon === void 0 ? null : _props$icon,
    mobileTitle = props.mobileTitle,
    children = props.children,
    email = props.email,
    fullName = props.fullName;
  var hasNameOrEmail = email || fullName;
  var renderProfileMobile = function renderProfileMobile() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(BASE_CSS, "__mobile-profile")
    }, icon && /*#__PURE__*/React__default.createElement("span", {
      className: "".concat(BASE_CSS, "__profile-icon")
    }, icon), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(BASE_CSS, "__profile-wrapper")
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "".concat(BASE_CSS, "__profile-name")
    }, fullName), /*#__PURE__*/React__default.createElement("span", {
      className: "".concat(BASE_CSS, "__profile-email")
    }, email)));
  };
  var renderMobileMenuAction = function renderMobileMenuAction() {
    var childrenWithSeparators = [];
    React__default.Children.forEach(children, function (child, index) {
      childrenWithSeparators.push(/*#__PURE__*/React__default.cloneElement(child, {
        isMobile: true,
        key: "header-mobile-menu-item-".concat(childrenWithSeparators.length)
      }));
      if (index < children.length - 1) {
        // add a separator to the end of each block of mobile menu items
        childrenWithSeparators.push(/*#__PURE__*/React__default.createElement("li", {
          role: "separator",
          key: "header-mobile-menu-item-".concat(childrenWithSeparators.length)
        }));
      }
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames(BASE_CSS, "".concat(BASE_CSS, "--mobile--container"))
    }, /*#__PURE__*/React__default.createElement("ul", {
      className: "".concat(BASE_CSS, "__mobile"),
      tabIndex: "-1",
      ref: ulRef,
      role: "menu",
      onKeyDown: mobielMenuKeyDownHandler,
      onFocus: mobileMenuFocusHandler,
      id: "header-composite-mobile-menu"
    }, hasNameOrEmail && renderProfileMobile(), mobileTitle && /*#__PURE__*/React__default.createElement("li", {
      role: "none",
      className: "".concat(BASE_CSS, "__mobile-title")
    }, mobileTitle), childrenWithSeparators));
  };
  return renderMobileMenuAction();
};
IlHeaderMobileMenuAction.propTypes = {
  icon: PropTypes.node,
  mobileTitle: PropTypes.string,
  fullName: PropTypes.string,
  email: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export { IlHeaderMobileMenuAction as default };
